import { useEffect, useState } from 'react';
import { useDeviceType } from '../contexts/DeviceTypeProvider';

interface BreakpointsProps {
    breakpoint: 'sm' | 'md' | 'lg' | number;
}

const breakpoints = {
    sm: 480,
    md: 768,
    lg: 990,
};

const getBreakpointValue = (breakpoint: BreakpointsProps['breakpoint']): number =>
    typeof breakpoint === 'number' ? breakpoint : breakpoints[breakpoint];

export const useBreakpoints = ({ breakpoint }: BreakpointsProps): boolean => {
    const breakpointValue = getBreakpointValue(breakpoint);
    const deviceType = useDeviceType();
    const [isSmallScreen, setIsSmallScreen] = useState(deviceType.isProbablyMobile);

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < breakpointValue);
        };

        window.addEventListener('resize', handleResize);

        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [breakpointValue]);

    return isSmallScreen;
};
